export default function PageHero({ eyebrow, title, description, image, compact = false, children }) {
  return (
    <section className={`page-hero ${compact ? 'page-hero--compact' : ''}`}>
      <div className="page-hero__image" style={{ backgroundImage: `linear-gradient(90deg, rgba(5,6,9,.96) 0%, rgba(5,6,9,.72) 48%, rgba(5,6,9,.18) 100%), url(${image})` }} />
      <div className="page-hero__content container">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {children && <div className="hero-actions">{children}</div>}
      </div>
    </section>
  );
}
